import { createBatch } from "./createMockData/createBatch";
import { creators } from "./creators";
import { moderators } from "./moderators";
import { photoShoots } from "./photoShoots";

import {
    QUEUES,
    MODERATION_TYPES
} from "frontend/components/fort/mod/photos/constants";

export const batches = [
    // TODO: Remember, this used to be the second batch...
    createBatch({ batchId: "batch-1" }),
    // ...and this was the first. Some tests relied on this order
    {
        ...createBatch({
            batchId: "batch-2-unassigned",
            moderatorId: "unassigned"
        }),
        moderationStatus: "BATCH_MOD_UNASSIGNED"
    },
    {
        ...createBatch({ batchId: "batch-3" }),
        containsSavedForLater: true
    },
    {
        ...createBatch({ batchId: "batch-4" }),
        containsReleaseOrEditorialFlags: true
    },
    {
        ...createBatch({ batchId: "batch-5" }),
        containsExplicitOrTextFlags: true
    },
    {
        ...createBatch({
            batchId: "batch-6",
            moderatorId: moderators[1].id,
            creator: creators[2]
        }),
        releaseCount: 11,
        photoShoot: photoShoots[1]
    },
    {
        ...createBatch({
            batchId: "batch-7",
            moderatorId: moderators[2].id,
            creator: creators[2]
        }),
        moderationStatus: "BATCH_CREATOR_BANNED",
        releaseCount: 0,
        photoShoot: null
    }
];

export const getBatchById = batchId => {
    return batches.find(b => b.id === batchId);
};

export const defaulSelectedBatch = getBatchById("batch-1");

export const batchIds = batches.map(b => b.id);

export const fetchBatchQueryVariables = {
    limit: 10,
    offset: 0,
    moderationType: MODERATION_TYPES[QUEUES.VIS_MOD],
    sortNewestToOldest: true,
    textSearch: "",
    showOnlySuspendedCreators: false
};
